import VoiceRepository from '@/repositories/VoiceRepository'
import MicrocmsGateway from '@/gateways/MicrocmsGateway'
import { ErrorType } from '@/common/errors'
import { VoiceNotFoundError } from '@/common/errors/voice'
export interface IFetchVoiceUseCaseParams {
  voiceRepository: VoiceRepository
  microcmsGateway: MicrocmsGateway
}

export default class FetchVoiceUseCase implements BaseUseCase {
  voiceRepository: VoiceRepository
  microcmsGateway: MicrocmsGateway

  constructor({ voiceRepository, microcmsGateway }: IFetchVoiceUseCaseParams) {
    this.voiceRepository = voiceRepository
    this.microcmsGateway = microcmsGateway
  }

  async execute(id: string) {
    try {
      const voice = await this.microcmsGateway.getVoice(id)
      this.voiceRepository.saveVoices([voice])
    } catch (error) {
      if (error.status === ErrorType.NOT_FOUND) {
        throw new VoiceNotFoundError(error.message)
      }
      throw error
    }
  }
}
